import { colors } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import Typography from '../common/typography/Typography';

// Hero Section Container
const HeroSection = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;  /* Full viewport height */
  padding: 0 20px;
  background-image: url("./static/hero_back.svg");  /* Use the imported SVG */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
 
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
  
  @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
`;

// Left and Right Columns (50/50)
const HeroRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 40px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const HeroLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const HeroImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const HeroTag = styled.div`

  display:flex;
  align-items:center;
  justify-content:center;
  margin:5px 0;

  border-radius: 90px;
  background: #fff;
  color: #5B63F6;
  height:40px;
  max-width:300px
 
`;

const HeroP = styled.p`
  max-width: 600px;
  color: #6F6D7B;
  text-align: left;
`;

const HeroTitle = styled.div`
  margin-top:2px
`;

const RegistredUsersContainer = styled.div`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 100%; 
  margin-top: 20px;

  img {
    width: 50%; 
    max-width: 100%;  
    height: auto; 
    cursor: pointer; 
  }
`;

const RegistredUsersText = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  padding:0px 5px;
  width: 50%;
`;
const DownloadButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between; 

  margin-top: 20px;
  width: 100%; 

  img {
    width: 50%;
    max-width: 100%;  
    cursor: pointer;
  }
`;
const DownloadImage = styled.img`
  width: 100%; 
  cursor: pointer;
`;

const Hero = () => {
  return (
    <HeroSection>
      <HeroLeft>
        <HeroTag>
          <Typography size="16px" weight="500">Realverse: Back To Real Life</Typography>
        </HeroTag>
        <HeroTitle>
          <Typography size="64px" weight="600">
            Rediscover New <span style={{ color: "#5B63F6" }}>Life</span> Beyond <span style={{ color: "#5B63F6" }}>Screens</span>
          </Typography>
        </HeroTitle>
        <HeroP>
          <Typography size="20px" weight="500">
            At Realverse, we believe in the power of balance. Our platform is
            designed to help you reconnect with the world outside of your devices,
            fostering healthier habits and a more fulfilling lifestyle.
          </Typography>
        </HeroP>
        <DownloadButtonsContainer>
          <DownloadImage src={"./static/Google_Play_Store_badge_EN.svg"} alt="Download on the App Store" />
          <DownloadImage src={"./static/Download_on_the_App_Store_Badge.svg"} alt="Get it on Google Play" />
        </DownloadButtonsContainer>
        <RegistredUsersContainer>
          <DownloadImage src={"./static/avatars.svg"} alt="users" />
          <RegistredUsersText>
            <Typography size="20px" weight="600" color={"#5B63F6"} >100,000 Registered Users +</Typography>
          </RegistredUsersText>
        </RegistredUsersContainer>
      </HeroLeft>
      <HeroRight>
        <HeroImage src="./static/hero_img.svg" alt="Hero" />
      </HeroRight>
    </HeroSection>
  );
};

export default Hero;
